<div
  #returnBlock
  class="payment-page">
  <div class="page-head">
    <div class="page-head__left"></div>
    <div class="page-head__right">
      <app-filter-button
        [isOpenFilter]="isOpenFilter"
        (toggleFilterEvent)="toggleFilter($event)"
        (uploadEvent)="upload()">
      </app-filter-button>
    </div>
  </div>

  <div class="payment-page__filer">
    <app-filter-block
      [additional]="filterAdditional"
      [(isOpenFilter)]="isOpenFilter">
      <app-return-page-filter
        [filterBanks]="filterBanks"
        [filterCurrencies]="filterCurrencies">
      </app-return-page-filter>
    </app-filter-block>

  </div>

  <div class="user-page__body">
    <div
      #tableBlock
      (scroll)="onScroll($event)"
      class="table">
      <div class="table-head">
        <div class="table__row">
          <div
            (click)="sortColumn('')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === ''"
              [class.asc]="sortColumnData?.order === 'asc'"
              [class.desc]="sortColumnData?.order === 'desc'"
              class="sortable__content">
              {{'RETURN_PAGE.ID' | translate}}
            </span>
          </div>
          <div
            (click)="sortColumn('BANK_PAYMENT_ID')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'BANK_PAYMENT_ID'"
              [class.asc]="sortColumnData?.order === 'asc'"
              [class.desc]="sortColumnData?.order === 'desc'"
              class="sortable__content">
              {{'RETURN_PAGE.BANK_PAYMENT_ID' | translate}}
            </span>
          </div>
          <div
            (click)="sortColumn('BANK_NAME')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'BANK_NAME'"
              [class.asc]="sortColumnData?.order === 'asc'"
              [class.desc]="sortColumnData?.order === 'desc'"
              class="sortable__content">
              {{'RETURN_PAGE.BANK_NAME' | translate}}
            </span>
          </div>
          <div
            (click)="sortColumn('AMOUNT')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'AMOUNT'"
              [class.asc]="sortColumnData?.order === 'asc'"
              [class.desc]="sortColumnData?.order === 'desc'"
              class="sortable__content">
              {{'RETURN_PAGE.AMOUNT' | translate}}
            </span>
          </div>
          <div
            (click)="sortColumn('CURRENCY')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'CURRENCY'"
              [class.asc]="sortColumnData?.order === 'asc'"
              [class.desc]="sortColumnData?.order === 'desc'"
              class="sortable__content">
              {{'RETURN_PAGE.CURRENCY' | translate}}
            </span>
          </div>
          <div
            (click)="sortColumn('FULL_NAME')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'FULL_NAME'"
              [class.asc]="sortColumnData?.order === 'asc'"
              [class.desc]="sortColumnData?.order === 'desc'"
              class="sortable__content">
              {{'RETURN_PAGE.FULL_NAME' | translate}}
            </span>
          </div>
          <div
            (click)="sortColumn('DATE')"
            class="column sortable table__row-head">
            <span
              [class.sorted]="sortColumnData?.field === 'DATE'"
              [class.asc]="sortColumnData?.order === 'asc'"
              [class.desc]="sortColumnData?.order === 'desc'"
              class="sortable__content">
              {{'RETURN_PAGE.DATE' | translate}}
            </span>
          </div>
        </div>
      </div>
      <div
        #tableBody
        class="table-body">
        <div
          *ngFor="let item of returnList"
          (dblclick)="openReturnDetail('dblclick', item.id)"
          (click)="openReturnDetail('click', item.id)"
          class="table__row">
          <div class="column table__row-data"><span class="mobile">{{'RETURN_PAGE.ID' | translate}}:</span>{{item.payment_id}}</div>
          <div class="column table__row-data"><span class="mobile">{{'RETURN_PAGE.BANK_PAYMENT_ID' | translate}}:</span>{{item.bank_payment_id}}</div>
          <div class="column table__row-data"><span class="mobile">{{'RETURN_PAGE.BANK_NAME' | translate}}:</span>{{item.bank_name}}</div>
          <div class="column table__row-data">{{item.amount}}</div>
          <div class="column table__row-data">{{item.currency}}</div>
          <div class="column table__row-data">{{item.full_name}} <span class="mobile">{{item.amount}} {{item.currency}}</span></div>
          <div class="column table__row-data"><span class="mobile">{{'RETURN_PAGE.FROM' | translate}}</span> {{item.date}}</div>
        </div>
      </div>
    </div>
  </div>
</div>


<app-modal
  [isFull]="true"
  [(isOpenModal)]="isOpenReturnDetail">
  <app-return-detail-component
    (copyDetail)="copyDetail()">
  </app-return-detail-component>
</app-modal>

<app-notification
  [icon]="'icon-2'"
  [notificationType]="'warning'">
  <app-copy-return-detail-success></app-copy-return-detail-success>
</app-notification>
